import React, { useEffect, useRef, useState } from "react";
import { IconButton } from "@material-ui/core";
import { connect } from "react-redux";
import Axios from "axios";
import "./ZoomStyle.css";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import EventLabel2, { init } from "../../../components/EventLabel2/EventLabel2";
import ZoomLogo from "./zoomLogo.svg";
import { isUsingChrome } from "../../../helpers/browser.helper";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { ResizeObserver } from "@juggle/resize-observer";
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function ZoomModule(props) {
  const [resizeObserver, setResizeObserver] = useState(null);
  const [isFullscreen, toggleScreenSize] = useState(false);
  const [browserAllowed, setBrowser] = useState(false);
  const { settings, eventId, enableZoomScreenShare, clientName, preview, template } = props;
  const { meetingId, active } = settings;
  const isFullscreenRef = useRef();
  const prevProps = usePrevious(props);
  isFullscreenRef.current = isFullscreen;
  const toggleFullscreen = () => {
    toggleScreenSize(!isFullscreen);
    setTimeout(() => sharingConfig(), 1500);
  };

  useEffect(() => {
    if (!preview) {
      if (meetingId && prevProps && prevProps.settings && meetingId !== prevProps.settings.meetingId) {
        initZoom();
      }
      if (active !== undefined && prevProps && prevProps.settings && prevProps.settings.active === true && active === false) {
        if (window.ZoomMtg) {
          window.ZoomMtg.leaveMeeting({});
        }
      }
      if (active && prevProps && prevProps.settings && prevProps.settings.active === false && active === true) {
        initZoom();
      }
    }
  }, [active, meetingId]);

  useEffect(() => {
    if (!preview) {
      const { active } = settings;
      if (!window.ZoomMtg) {
        addReact();
      } else if (active) {
        initZoom();
      }
      init(eventId, "DigitalMeeting.Zoom", "swe");
      window.addEventListener("beforeunload", function () {
        if (window.ZoomMtg) {
          try {
            window.ZoomMtg.leaveMeeting({});
          } catch (error) {
            console.error("Could not leave meeting");
          }
        }
      });
    }
    setBrowser(isUsingChrome());
    return () => {
      if (window.ZoomMtg) {
        try {
          window.ZoomMtg.leaveMeeting({});
        } catch (error) {
          console.error("Could not leave meeting");
        }
      }
    };
  }, []);

  const initZoom = (e) => {
    const { settings } = props;
    const { meetingId, password, active } = settings;
    if (!window.ZoomMtg || !active) return;
    if (!meetingId) return;

    window.ZoomMtg.setZoomJSLib("https://source.zoom.us/1.8.6/lib", "/av");
    window.ZoomMtg.preLoadWasm();
    window.ZoomMtg.prepareJssdk();

    Axios.get(`./api/meeting/zoomjoin/${eventId}?meetingNumber=${meetingId}&role=0`)
      .then((res) => {
        if (res.data.signature !== "") {
          window.ZoomMtg.init({
            leaveUrl: res.data.leaveUrl || window.location.href,
            isSupportAV: true,
            videoHeader: false,
            disableInvite: false,
            isSupportChat: false,
            /* sharingMode: 'fit', */
            isSupportQA: false,
            isShowJoiningErrorDialog: false,
            screenShare: true,
            videoDrag: false,
            showMeetingHeader: false,
            success: () => {
              window.ZoomMtg.join({
                signature: res.data.signature,
                meetingNumber: meetingId,
                userName: clientName || "Guest",
                apiKey: res.data.apiKey,
                userEmail: "noreply@jirango.com",
                passWord: password,
                success: (success) => {
                  var zoomFrame = document.getElementById("zoomFrame");
                  var zmmtgRoot = document.getElementById("zmmtg-root");
                  if (zoomFrame) {
                    zoomFrame.append(zmmtgRoot);
                    zmmtgRoot.style.display = "block";
                  }
                  screenLoaded();
                },
                error: (error) => {
                  console.error(error);
                },
              });
            },
            error: (error) => {
              console.error(error);
            },
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const addReact = () => {
    var reactScript = document.createElement("script");
    reactScript.src = "https://source.zoom.us/1.8.6/lib/vendor/react.min.js";
    document.head.appendChild(reactScript);
    reactScript.onload = (e) => addReactDom();
  };
  const addReactDom = () => {
    var reactDomScript = document.createElement("script");
    reactDomScript.src = "https://source.zoom.us/1.8.6/lib/vendor/react-dom.min.js";
    document.head.appendChild(reactDomScript);
    reactDomScript.onload = (e) => addRedux();
  };
  const addRedux = () => {
    var redux = document.createElement("script");
    redux.src = "https://source.zoom.us/1.8.6/lib/vendor/redux.min.js";
    document.head.appendChild(redux);
    redux.onload = (e) => addReduxThunk();
  };
  const addReduxThunk = () => {
    var reduxThunk = document.createElement("script");
    reduxThunk.src = "https://source.zoom.us/1.8.6/lib/vendor/redux-thunk.min.js";
    document.head.appendChild(reduxThunk);
    reduxThunk.onload = (e) => addJquery();
  };
  const addJquery = (response) => {
    var jqueryScript = document.createElement("script");
    jqueryScript.src = "https://source.zoom.us/1.8.3/lib/vendor/jquery.min.js";
    document.head.appendChild(jqueryScript);
    jqueryScript.onload = (e) => addLodash();
  };
  const addLodash = (response) => {
    var lodashScript = document.createElement("script");
    lodashScript.src = "https://source.zoom.us/1.8.6/lib/vendor/lodash.min.js";
    document.head.appendChild(lodashScript);
    lodashScript.onload = (e) => addZoom();
  };
  const addZoom = (response) => {
    var zoomScript = document.createElement("script");
    zoomScript.src = "https://source.zoom.us/zoom-meeting-1.8.6.min.js";
    document.head.appendChild(zoomScript);
    zoomScript.onload = (e) => initZoom(e);
  };
  const sharingConfig = () => {
    let sharingCanvas = document.querySelector(".sharee-container__canvas");
    let canvas = null;

    const { posY, posX, height, width } = props;
    let zh = parseFloat(height);
    let zw = parseFloat(width);
    let x = parseFloat(posX);
    let y = parseFloat(posY);

    if (!sharingCanvas /*  && !videoCanvas */) {
      return;
    }
    canvas = sharingCanvas;

    let h = window.innerHeight;
    let w = window.innerWidth;

    if (isFullscreenRef.current) {
      h -= 52;
      w = h * 1.777;
      let mLeft = (window.innerWidth - w) / 2;
      canvas.style.height = h + "px";
      canvas.style.width = w + "px";
      canvas.style.maxWidth = w + "px";
      canvas.style.left = mLeft + "px";
      canvas.style.marginLeft = "0px";
    } else {
      h = h * (zh / 100);
      h -= 52;
      w = h * 1.777;
      let mLeft = window.innerWidth * (x / 100);

      if (w < window.innerWidth * (zw / 100)) {
        let rest = window.innerWidth * (zw / 100) - w;
        mLeft = rest;
      }
      if (window.innerWidth < 1400) {
        mLeft = 0;
      }

      canvas.style.height = h + "px";
      canvas.style.width = w + "px";
      canvas.style.maxWidth = w + "px";
      canvas.style.left = mLeft / 2 + "px";
      canvas.style.marginLeft = "0px";
    }
    canvas.style.zoom = 0;
    suspensionWindow();
  };
  const suspensionWindowOnUpdate = () => {
    const bFrame = document.getElementsByClassName("suspension-img-wrapper")[1];
    let status = -1;
    if (bFrame && bFrame.style.zIndex == 0) {
      status = 0;
    } else if (bFrame && bFrame.style.zIndex == -1) {
      status = 1;
    }
    let suspensionWindows = document.getElementsByClassName("suspension-window");
    if (suspensionWindows.length > 0) {
      for (let index = 0; index < suspensionWindows.length; index++) {
        if (status === 1) {
          suspensionWindows[index].style.opacity = 0;
        }
        if (status === 0) {
          suspensionWindows[index].style.opacity = 1;
        }
      }
    }
  };
  const screenLoaded = () => {
    let videoBtn = document.getElementsByClassName("join-audio")[1];
    if (videoBtn) {
      videoBtn.addEventListener("click", suspensionWindowOnUpdate);
    }
    setInterval(() => sharingConfig(), 3000);
    suspensionWindow();
  };
  const suspensionWindow = () => {
    const { posY, posX, height, width } = props;

    let zh = parseFloat(height);
    let zw = parseFloat(width);
    let x = parseFloat(posX);
    let y = parseFloat(posY);

    if (isFullscreenRef.current) {
      zh = 100;
      zw = 100;
    }

    let h = window.innerHeight;
    let w = window.innerWidth;
    let videoHeight = h * (zh / 100) * 0.2;

    w = videoHeight * 1.777;

    let cornerRight = 20;
    let cornerTop = 20;

    const videoCanvas = document.querySelector(".active-video-container__wrap");

    if (!isFullscreenRef.current) {
      cornerRight = window.innerWidth * (zw / 100) + window.innerWidth * (x / 100) - window.innerWidth - 20;
      cornerTop = window.innerHeight * (y / 100) + 20;
    }
    if (videoCanvas) {
      videoCanvas.style.width = (h * (zh / 100) - 54) * 1.777 + "px";
    }
    var suspW = document.getElementsByClassName("suspension-window-container");
    if (suspW.length == 0) setTimeout(() => this.suspensionWindow(), 10000);
    for (let index = 0; index < suspW.length; index++) {
      suspW[index].style.width = w + "px";
      suspW[index].style.height = videoHeight + "px";
      suspW[index].style.right = Math.abs(cornerRight) + "px";
      suspW[index].style.top = Math.abs(cornerTop) + "px";
    }
    const hardToFindDiv = document.querySelector(".meeting-app");
    if (hardToFindDiv.children && hardToFindDiv.children.length > 0) {
      if (hardToFindDiv.children[2] && hardToFindDiv.children[2].nodeName == "DIV") {
        //  hardToFindDiv.children[2].style.height = zh + "vh";
          hardToFindDiv.children[2].style.height = hardToFindDiv.clientHeight + "px";
          const resizeTarget = hardToFindDiv.children[2];
          if(!resizeObserver){
            const ro = new ResizeObserver((entries, observer) => {
              entries.forEach((e, index) => {
                  resizeTarget.style.height = e.target.clientHeight + "px";
              });
            });
            ro.observe(hardToFindDiv);
            setResizeObserver(ro);
          }
      }
    }
  };

  if (preview) return <EditorPreview />;

  return (
    <div
      id="zoomFrame"
      style={{
        position: isFullscreen ? "fixed" : "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        background: "#222",
        top: 0,
        left: 0,
      }}
    >
      {active ? <div className={!enableZoomScreenShare ? "zoom-toolbar-block" : "zoom-toolbar-block-slim"} /> : null}
      {!active ? (
        <div className="center-in zoom-text" style={template ? template.subtitle : {}}>
          <EventLabel2 name="WaitingForMeetingToStart" groupName="DigitalMeeting.Zoom" />
        </div>
      ) : null}
      {active ? (
        <div className="screen-options">
          {!isFullscreen ? (
            <IconButton style={{ color: "#b5b5b5" }} onClick={() => toggleFullscreen()}>
              <FullscreenIcon />
            </IconButton>
          ) : (
            <IconButton style={{ color: "#b5b5b5" }} onClick={() => toggleFullscreen()}>
              <FullscreenExitIcon />
            </IconButton>
          )}
        </div>
      ) : null}

    </div>
  )
}
function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : undefined,
  };
}
export default connect(mapStateToProps)(ZoomModule);

const EditorPreview = () => {
  return (
    <div className="zoom-preview">
      <div className="centered-text text-center">
        <img src={ZoomLogo} style={{ margin: "auto" }} />
        <h1 style={{ color: "#eee", fontSize: "1rem", marginTop: 5 }}>
          <SystemLabel name="ShowOnlyInEditor" />
        </h1>
      </div>
    </div>
  );
};

const NotValidBrowser = () => {
  return (
    <div className="zoom-browser-validation">
      <div className="links"></div>
      <h1>
        <SystemLabel name="NotAllowedBrowser" />
      </h1>
      <h2>
        <SystemLabel name="NotAllowedBrowser" />
      </h2>
    </div>
  );
};
